import { EffectsSetting, readEffects } from "./effects-setting.ts";

/**
 * The page's Effects choice (ADR-141 decision F15), the one `EffectsSetting` every surface that draws particles reads. A
 * change made in another tab arrives as a `storage` event and applies here at once, with no reload.
 */
export const PAGE_EFFECTS = new EffectsSetting(readEffects());

if (typeof window !== "undefined") {
  window.addEventListener("storage", () => PAGE_EFFECTS.refresh());
}
